import { endPoints } from "../../constants/configuration";
import client from "../../utils/client";

export const getInfomoViewListApi = async ({ tenantId, authToken, userId, params, payload }) => {
    try {
        const { data } = await client().post(endPoints.beki + `/seat/config/infomo`, payload, {
            params,
            headers: {
                common: {
                    tai_tenant: parseInt(tenantId),
                    tai_token: authToken,
                    tai_user: userId,
                },
            },
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
};


export const getAccountListApi = async ({ tenantId, authToken, userId, params}) => {
    try {
        const { data } = await client().get(endPoints.beki + `/seat/custom`, {
            params,
            headers: {
                common: {
                    tai_tenant: parseInt(tenantId),
                    tai_token: authToken,
                    tai_user: userId,
                },
            },
        });
        return data;
    } catch (error) {
        // get axios errors from error.response
        console.log(error);
        throw error;
    }
};